import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

const ShareCta = () => {
  const {t} = useTranslation()
  return (
    <Link to="/my-projects" className="share-cta">
      <span className="share-cta-icon" aria-hidden>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M12 2.5l2.6 5.3 5.9.85-4.25 4.15 1 5.85L12 15.85 6.75 18.65l1-5.85L3.5 8.65l5.9-.85L12 2.5z"
            fill="currentColor"
            stroke="none"
          />
        </svg>
      </span>
      <span className="share-cta-text">
        <strong>
          {t('templates.shareCta.title')}
          <span className="share-cta-pill">{t('templates.shareCta.pill')}</span>
        </strong>
        <span>{t('templates.shareCta.sub')}</span>
      </span>
      <span className="share-cta-arrow" aria-hidden>
        →
      </span>
    </Link>
  )
}

export default ShareCta
